import base_getters from '@/store/modules/base/getters.js'

export default {
    ...base_getters,
    get_loaded_for_project_id: (state) => state.loaded_for_project_id,
    get_loading: (state) => state.loading,
    get_loaded: (state) => state.loaded,
    get_total_count: (state) => state.total_count || 0,
}
